import { Link } from "wouter";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { testimonials } from "@/data/testimonials";

const Testimonials = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-primary">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">Отзиви от клиенти</h1>
            <p className="text-xl text-white max-w-2xl mx-auto">
              Вижте какво казват нашите доволни клиенти за работата ни
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Клиентски отзиви</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
            <p className="text-gray-700 max-w-2xl mx-auto">
              Ние се гордеем с постигнатите резултати и с отзивите, които получаваме от нашите клиенти.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-lg shadow-md p-6 h-full flex flex-col">
                <div className="flex items-center mb-4">
                  <div className="text-[#FFC857] flex">
                    {[...Array(Math.floor(testimonial.rating))].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                    {testimonial.rating % 1 !== 0 && <FaStarHalfAlt />}
                  </div>
                </div>
                <p className="italic text-gray-700 mb-6 flex-grow">"{testimonial.text}"</p>
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full bg-gray-300 overflow-hidden mr-4">
                    <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <h4 className="font-heading font-bold">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Satisfaction Section */}
      <section className="py-20 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-4">Удовлетвореност на клиентите</h2>
            <div className="w-24 h-1 bg-[#FFC857] mx-auto mb-6"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="text-5xl font-bold text-primary mb-4">98%</div>
              <p className="text-gray-700">от клиентите ни са доволни от крайния резултат</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="text-5xl font-bold text-primary mb-4">95%</div>
              <p className="text-gray-700">от проектите са завършени в уговорения срок</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="text-5xl font-bold text-primary mb-4">87%</div>
              <p className="text-gray-700">от клиентите ни идват по препоръка</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-6">Станете наш доволен клиент</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Свържете се с нас, за да обсъдим вашия проект и да получите безплатна оферта.
          </p>
          <Link href="/contact">
            <button className="bg-[#D95204] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 text-lg">
              Свържете се с нас
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
